<template>
  <div class="analytic-tab-pane tab-pane">
    <PaymentChartsGross v-if="showComponent"/>

    <PaymentChartsReports />
  </div>
</template>

<script>
  import PaymentChartsGross from './PaymentChartsGross'
  import PaymentChartsReports from './PaymentChartsReports'

  export default {
    name: 'PaymentChartsTab',
    components: {
      PaymentChartsGross, PaymentChartsReports
    },
    data() {
      return {
        showComponent: false
      }
    }
  }
</script>
